import { userConstants } from '../constants';
import { Cookies } from "react-cookie";
import { cookieConstants } from "../constants";
const cookies = new Cookies();

let user = cookies.get(cookieConstants.USER);
let token = cookies.get(cookieConstants.TOKEN);

const logged = token ? true : false;

const initialState = {
  loggedIn: logged,
  user: user,
  loading: false,
  error: {}
}

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loading: true,
        loggingIn: false
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        loggedIn: true,
        user: action.user,
      };
    case userConstants.USERS_ME_SUCCESS:
      return {
        ...state,
        user: action.user,
        loggedIn: true,
      };
    case userConstants.LOGIN_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    case userConstants.LOGOUT:
      return {};
    default:
      return state
  }
}